import {handleFetchError, HtmlDialog, showNotice} from "../helpers/functions.js";
import JSX from "../helpers/react.js";
import {IProfileJson, IUserJson} from "../../../../nodeserver/structs/database";
import {ServerApi} from "../api.js";
import {getAcceptHeader} from "../config.js";

const themes = [
    {
        'cls': '',
        'name': 'Системная',
    },
    {
        'cls': 'light',
        'name': 'Светлая'
    },
    {
        'cls': 'dark',
        'name': 'Тёмная'
    },
    {
        "cls": 'tr-light',
        'name': 'Светло-прозрачная'
    },
    {
        'cls': 'tr-dark',
        'name': 'Тёмно-прозрачная'
    }
]


function OneBackgroundPreview({i}: { i: number }) {
    return (
        <li>
            <label for={`theme_id_${i}`}>
                {i ?
                    <img src={`//static.yani.tv/img/bg/${i}.${i < 15 ? 'jpg' : 'avif'}`} loading="lazy" alt={`Тема ${i}`}
                         title={`Тема ${i}`}/>
                    : 'Без фона'
                }
            </label>
            <input name="theme_id" type="radio" id={`theme_id_${i}`} value={i}
                   checked={$.cookie('theme_id') == i + "" ? '' : undefined} onInput={onInput}/>
        </li>
    )

    function onInput(this: HTMLElement) {
        const theme_id = $(this).val()! as string;
        $.cookie('theme_id', theme_id, {path: '/', expires: new Date((+new Date) + 3600_000 * 24 * 356)});
        const $body = $('body').addClass('theme-change').attr('data-theme-id', theme_id);
        setTimeout(() => $body.removeClass('theme-change'), 300);
    }
}

function Switch(props: { id: string, checked: boolean, title: string }) {
    return (
        <label for={props.id} className="gui-switch">
            {props.title}
            <input className="changeable" type="checkbox" role="switch" id={props.id}
                   checked={props.checked ? "checked" : undefined}/>
        </label>
    )
}

export function SettingsDialog({user}: { user: IProfileJson }) {
    console.log(user);
    const muteIcon: JSX.RefObject = {}
    const ans = (
        <HtmlDialog className="settings-dialog">
            <div className="top-data">
                <div className="fa fa-cog loading-settings-icon"/>
                <div className="fa fa-times-circle top-icon-close-dialog cancel-button" style="margin: 5px"/>
                <h1>Настройки</h1>
                <div className="content settings">
                    <div className="settings-container scroll-flex-container">
                        <section>
                            <h3>О себе</h3>
                            <p>Основная информация профиля</p>
                            <label for="sex" className="gui-switch">
                                Пол:
                                <select className="slim-select changeable" id="sex" data-open-pos="up">
                                    {
                                        ...['Не выбрано', 'Мужской', 'Женский'].map((sex, id) => (
                                            <option value={id}
                                                    selected={user.sex === id ? 'selected' : undefined}>{sex}</option>
                                        ))
                                    }
                                </select>
                            </label>
                            <br/>
                            <label for="age">
                                Дата рождения:
                                <input className="changeable" type="date" min="1900-01-01"
                                       max={(new Date).getFullYear() + "-01-01"}
                                       value={user.bdate ? new Date(user.bdate * 1000).toISOString().split('T')[0] : undefined}
                                       id="bdate"
                                       data-open-pos="up"
                                       style="background: var(--background-first); color: var(--main-text)"
                                />
                            </label>
                            <p>
                                <br/>
                                <label for="about">Текст, видимый снизу профиля</label>
                                <br/>
                                <textarea id="about" className="changeable" style="resize:vertical; height: 250px"
                                          placeholder="Несколько слов о себе">{
                                    user.about
                                }</textarea>
                            </p>
                        </section>
                        <section>
                            <h3>Интерфейс</h3>
                            <p>Настройка внешней части сайта</p>
                            <label for="site-design">Дизайн</label>
                            <p>
                                <select className="slim-select" id="site-design" onChange={function () {
                                    const isOld: string = $(this).val()! as string;
                                    $.cookie('old_design', isOld, {
                                        path: '/',
                                        expires: new Date((+new Date) + 3600_000 * 24 * 356)
                                    });
                                    const $body = $('body')
                                        .css('transition', '.3s')
                                        [isOld == '1' ? 'addClass' : 'removeClass']('no-border');
                                    setTimeout(() => $body.css('transition', ''), 300);
                                }}>
                                    <option value="0" selected={$.cookie('old_design') != '1' ? '' : undefined}>Новый
                                    </option>
                                    <option value="1" selected={$.cookie('old_design') == '1' ? '' : undefined}>Старый
                                    </option>
                                </select>
                            </p>
                            <label for="settings-theme">Тема</label>
                            <select className="slim-select" id="settings-theme" onChange={function () {
                                const newTheme: string = $(this).val()! as string;
                                $.cookie('theme', newTheme, {
                                    path: '/',
                                    expires: new Date((+new Date) + 3600_000 * 24 * 356)
                                });
                                const attribute = themes[+newTheme].cls;
                                const $body = $('body')
                                    .addClass('theme-change')
                                    .attr('data-theme', attribute);
                                setTimeout(() => $body.removeClass('theme-change'), 300);
                            }}>
                                {
                                    ...themes.map((theme, id) => (
                                        <option value={id}
                                                selected={$.cookie('theme') == id + "" ? 'selected' : undefined}>{theme.name}</option>
                                    ))
                                }
                            </select>
                            <label for="settings-theme-id">
                                Фон сайта:
                            </label>
                            <ul className="settings-theme-id">
                                {
                                    ...Array.from(Array(16).keys())
                                        .map(i => {
                                            return (
                                                <OneBackgroundPreview i={i}/>
                                            );
                                        })
                                }
                            </ul>
                            <button className="main-button profile-bg-img bordered"
                                    style="height: auto;margin: 0 auto;">Кастомизация профиля
                            </button>
                        </section>
                        <section>
                            <h3>
                                Уведомления <span className="notification-volume" onClick={function () {
                                muteIcon.value!.classList.toggle('fa-volume-up');
                                muteIcon.value!.classList.toggle('fa-volume-off');
                                let muted = localStorage.muted === 'true';
                                localStorage.muted = (!muted).toString() as 'true' | 'false';
                            }}>
                                <i className={localStorage.muted === 'true' ? 'fa fa-volume-off' : "fa-volume-up fa"}
                                   ref={muteIcon}/>
                            </span>
                            </h3>
                            <p>Наш бот будет присылать уведомления в <b>ВК</b>/<b>Telegram</b> о выходе новых серий,
                                лайках и т.п.</p>
                            <p><b>Внимание!</b> Чтобы эта функция заработала, надо привязать соответсвующий аккаунт
                                и <b>отправить сообщение нашему боту</b> в <a href="//vk.me/yummyanime_official"
                                                                              target="_blank">ВК</a> и <a
                                    href="//t.me/yummy_animeBot" target="_blank">Телеграм</a></p>
                            <Switch id="send_vk_notifications" checked={user.notifications.vk}
                                    title="Уведомления в ВК"/>
                            <br/>
                            <Switch id="send_tg_notifications" checked={user.notifications.telegram}
                                    title="Уведомления в Telegram"/>
                        </section>
                        <section>
                            <h3>Приватность</h3>
                            <p>Какая информация будет видна в Вашем профиле</p>
                            <p style="display: flex;justify-content: space-between;align-items: center;">
                                Кто видит Ваши списки аниме
                                <select id="lists_privacy" className="slim-select changeable" style="min-width: 140px;">
                                    <option value="public"
                                            selected={user.lists_privacy === 'public' ? '' : undefined}>Все
                                    </option>
                                    <option value="friends"
                                            selected={user.lists_privacy === 'friends' ? '' : undefined}>Друзья
                                    </option>
                                    <option value="authed"
                                            selected={user.lists_privacy === 'authed' ? '' : undefined}>Авторизованные
                                        пользователи
                                    </option>
                                    <option value="none"
                                            selected={user.lists_privacy === 'none' ? '' : undefined}>Никто
                                    </option>
                                </select>
                            </p>
                            <br/>
                            <Switch id="hide_vk" checked={!user.privacy.vk_public} title="Скрывать ВК"/>
                            <br/>
                            <Switch id="hide_tg" checked={!user.privacy.tg_public} title="Скрывать Telegram"/>
                            <br/>
                            <Switch id="hide_shiki" checked={!user.privacy.shiki_public} title="Скрывать Shikimori"/>
                            <br/>
                        </section>
                    </div>
                </div>
            </div>
        </HtmlDialog>
    )


    return ans;
}


let lastReject: any = null;
$('html')
    //Settings
    .on('click', '.settings-button', async function () {
        const $this = $(this);
        if ($this.hasClass('blocked')) return;
        $this.addClass('blocked');
        try {
            const user = await ServerApi.profile.get();
            const ans = (<SettingsDialog user={user}/>);
            document.body.appendChild(ans);
            $(ans).find('select.slim-select').slimSelect(v => v);

        } finally {
            $this.removeClass('blocked');
        }
    })
    .on('input change', '.settings-dialog .changeable', async function () {
        try {
            await new Promise((resolve, reject) => {
                if (lastReject) lastReject();
                setTimeout(resolve, 300);
                lastReject = reject;
            })
        } catch (e) {
            return;
        }
        const dialog = $('.settings-dialog'),
            loadingIcon = $('.loading-settings-icon').addClass('active'),
            currDate = +new Date();
        dialog.data('last', currDate);
        await new Promise(resolve => setTimeout(resolve, 500));
        if (dialog.data('last') != currDate) return;
        const values = Array.from(dialog.find('.changeable')).map(el => {
                const ans: any[] = [el.id],
                    $el = $(el);
                if ($el.attr('type') === 'checkbox')
                    ans.push($el.is(":checked") ? 'on' : 'off');
                else ans.push($el.val());
                return ans;
            }).filter(e => e[0]),
            valuesDict = Object.fromEntries(values as ([string, any])[]);
        try {
            valuesDict['hide'] = {
                vk: valuesDict['hide_vk'] === 'on',
                tg: valuesDict['hide_tg'] === 'on',
                shiki: valuesDict['hide_shiki'] === 'on',
            }
            valuesDict['notifications'] = {
                vk: valuesDict['send_vk_notifications'] === 'on',
                tg: valuesDict['send_tg_notifications'] === 'on',
            }
            valuesDict['sex'] = +valuesDict['sex']
            delete valuesDict['send_vk_notifications'];
            delete valuesDict['send_tg_notifications'];
            delete valuesDict['hide_vk'];
            delete valuesDict['hide_tg'];
            delete valuesDict['hide_shiki'];
            loadingIcon.data('ended', false);
            await ServerApi.profile.setSettings(valuesDict);
            showNotice('Изменения успешно сохранены', 'Успех');
        } catch (e) {
            handleFetchError(e);
        } finally {
            loadingIcon.data('ended', true);
            setTimeout(() => loadingIcon.data('ended') && loadingIcon.removeClass('active'), 300);
        }
    })
